import styled from 'styled-components';
import { colors } from 'bench-style-constants';

export default styled.div`
  margin: 12px;
  padding: 12px;
  background: ${colors.sand};
  border: 1px solid ${colors.silt};
  border-radius: 3px;
`;
